import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ViewbookingsComponent } from './views/viewbookings/viewbookings.component';
import { CustomersComponent } from './views/customers/customers.component';
import { UserLoginComponent } from './views/user-login/user-login.component';
import { AuthGuard } from './guards/auth.guard';
import { HomeComponent } from './views/home/home.component';
import { SearchbookingsComponent } from './views/searchbookings/searchbookings.component';
import { UsersComponent } from './views/users/users.component';
import { AngenciesComponent } from './views/agencies/agencies.component';
import { LandingPageComponent } from './views/landing-page/landing-page.component';
import { ReportsComponent } from './views/reports/reports.component';
import { SettingsComponent } from './views/settings/settings.component';
import { RegisterComponent } from './views/user-register/register.component';

import { Roles } from './models/roles.enum';
import { InvoiceComponent } from './views/invoice/invoice.component';
import { TermsComponent } from './views/terms/terms.component';
import { DirectionsComponent } from './views/directions/directions.component';
import { ResetComponent } from './views/reset/reset.component';
import { UserPasswordComponent } from './views/user-password/user-password.component';
import { ContactUsComponent } from './views/contact-us/contact-us.component';

export const routes: Routes = [
  {
    path: 'home', component: HomeComponent, canActivate: [AuthGuard],
    data: { allowedRoles: [], name: 'Home', icon: 'home' }
  },
  {
    path: 'search/bookings', component: SearchbookingsComponent, canActivate: [AuthGuard],
    data: {
      allowedRoles: [Roles.Administrator, Roles.Client_Liason_Officer, Roles.Agent, Roles.AgencyAdministrator], name: 'Search Bookings', icon: 'search'
    }
  },
  {
    path: 'view/bookings', component: ViewbookingsComponent, canActivate: [AuthGuard],
    data: { allowedRoles: [Roles.Administrator, Roles.Client_Liason_Officer], name: 'View Bookings', icon: 'book' }
  },
  {
    path: 'view/customers', component: CustomersComponent, canActivate: [AuthGuard],
    data: { allowedRoles: [Roles.Administrator, Roles.Client_Liason_Officer, Roles.Agent, Roles.AgencyAdministrator], name: 'Customers', icon: 'users' }
  },
  {
    path: 'view/agencies', component: AngenciesComponent, canActivate: [AuthGuard],
    data: { allowedRoles: [Roles.Administrator], name: 'Agencies', icon: 'handshake-o' }
  },
  { path: 'login', component: UserLoginComponent },
  { path: 'register', component: RegisterComponent },
  {
    path: 'users', component: UsersComponent, canActivate: [AuthGuard],
    data: { allowedRoles: [Roles.Administrator], name: 'Users', icon: 'user-circle' }
  },
  {
    path: 'reports', component: ReportsComponent, canActivate: [AuthGuard],
    data: { allowedRoles: [Roles.Administrator, Roles.Client_Liason_Officer], name: 'Reports', icon: 'book' }
  },
  {
    path: 'settings', component: SettingsComponent, canActivate: [AuthGuard],
    data: { allowedRoles: [Roles.Administrator], name: 'Settings', icon: 'wrench' }
    },
    { path: 'terms', component: TermsComponent },
    { path: 'directions', component: DirectionsComponent },
  { path: '', component: LandingPageComponent },
    { path: 'reset', component: ResetComponent },
    { path: 'forgot', component: UserPasswordComponent },
    { path: 'contact', component: ContactUsComponent }
   
  // { path: 'pagenotfound', component: UserLoginComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
